import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import { MenuItemWithIcon, ModalOpenButton, PopoverOpenButton } from "@msys/ui";
import {
  ArrowDropDown as ArrowDropDownIcon,
  Publish as PublishIcon,
} from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ButtonProps,
  MenuList,
  Stack,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { QuoteTemplatePublishModal } from "./QuoteTemplatePublishButton.js";
import { QuoteTemplateDiscardUnpublishedChangesModal } from "./QuoteTemplateDiscardUnpublishedChangesButton.js";

interface Props {
  docId: string;
  pathToDoc: string;
  buttonProps?: ButtonProps;
  buttonTitle?: string;
}

export const QuoteTemplatePublishAndDiscardButton = ({
  docId,
  pathToDoc,
  buttonProps,
  buttonTitle,
}: Props) => {
  const { t } = useTranslate(["TemplatesSharing", "Global"]);
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <>
      <ButtonGroup>
        <ModalOpenButton
          Modal={QuoteTemplatePublishModal}
          modalProps={{
            docId,
            pathToDoc,
          }}
        >
          <Button
            startIcon={<PublishIcon />}
            variant="contained"
            color="primary"
            {...buttonProps}
          >
            {buttonTitle ?? t("Publish changes", { ns: "TemplatesSharing" })}
          </Button>
        </ModalOpenButton>

        <PopoverOpenButton
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          content={
            <Stack
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <MenuList autoFocusItem>
                <ModalOpenButton
                  Modal={QuoteTemplatePublishModal}
                  modalProps={{
                    docId,
                    pathToDoc,
                  }}
                >
                  <MenuItemWithIcon icon={<PublishIcon />}>
                    {t("Publish changes", { ns: "TemplatesSharing" })}
                  </MenuItemWithIcon>
                </ModalOpenButton>
                <ModalOpenButton
                  Modal={QuoteTemplateDiscardUnpublishedChangesModal}
                  modalProps={{ docId, pathToDoc }}
                >
                  <MenuItemWithIcon icon={<SettingsBackupRestoreIcon />}>
                    {t("Revert changes", { ns: "TemplatesSharing" })}
                  </MenuItemWithIcon>
                </ModalOpenButton>
              </MenuList>
            </Stack>
          }
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            {...buttonProps}
          >
            <ArrowDropDownIcon
              sx={{
                transition: "transform 0.2s ease-out",
                ...(open ? { transform: `rotate(-180deg)` } : undefined),
              }}
            />
          </Button>
        </PopoverOpenButton>
      </ButtonGroup>
    </>
  );
};
